/**
 * Ryan O'Dowd
 * 2023-12-29
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  const innerBackgroundColor = colors.primary;
  const borderColor = colors.primaryLight;

  return {
    listItemContainer: {
      display: 'flex',
      // @TODO: this width should be 100%, but that's not working for shorter names
      width: '100%',
      // @TODO: maxHeight: '80%',
      // @TODO: paddingTop: 4,
      // @TODO: paddingRight: 8, okay to remove everywhere?
      // @TODO: paddingBottom: 4,
      // @TODO: paddingLeft: 8, okay to remove everywhere?
      paddingHorizontal: globalScale * 4,
    },
    listItemInner: {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
      maxWidth: '100%',
      borderWidth: globalScale * 4,
      borderColor,
      borderRadius: globalScale * 12,
      backgroundColor: innerBackgroundColor,
      padding: globalScale * 8,
    },
    listItemInnerOpenAccordion: {
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    accentListItemInner: {
      borderColor: colors.accent,
      backgroundColor: colors.completeBg,
    },
    accordionContent: {
      // @TODO: flex: 1,
      borderWidth: globalScale * 4,
      borderColor,
      borderRadius: globalScale * 12,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      backgroundColor: innerBackgroundColor,
    },
    accentAccordionContent: {
      borderColor: colors.accent,
      backgroundColor: colors.completeBg,
    },
  };
};

export default getStyles;
